import { map, toArray } from "./fable_modules/fable-library.3.7.14/Seq.js";
import { rangeDouble } from "./fable_modules/fable-library.3.7.14/Range.js";
import { FSharpMap__get_Item, ofList } from "./fable_modules/fable-library.3.7.14/Map.js";
import { map as map_1 } from "./fable_modules/fable-library.3.7.14/List.js";
import { escapeUriString } from "./fable_modules/fable-library.3.7.14/Util.js";
import { audioFilename } from "./Assets.fs.js";
import { printf, toText } from "./fable_modules/fable-library.3.7.14/String.js";
import { SoundEffect_get_All } from "./Model.fs.js";

function createOverlayingAudioPlayer(path) {
    const audioPlayers = toArray(map((_arg1) => (new Audio(path)), rangeDouble(0, 1, 4)));
    let currentIndex = 0;
    return (volume) => {
        audioPlayers[currentIndex].volume = volume;
        audioPlayers[currentIndex].play();
        currentIndex = (((currentIndex === (audioPlayers.length - 1)) ? 0 : (currentIndex + 1)) | 0);
    };
}

const soundEffects = ofList(map_1((tupledArg) => [tupledArg[0], createOverlayingAudioPlayer(tupledArg[1])], map_1((soundEffectType) => {
    let arg10;
    return [soundEffectType, (arg10 = escapeUriString(audioFilename("mp3", soundEffectType)), toText(printf("assets/sounds/%s"))(arg10))];
}, SoundEffect_get_All())));

export function playSoundEffect(soundEffect) {
    FSharpMap__get_Item(soundEffects, soundEffect)(1);
}

export function playSoundEffectAtVolume(volume, soundEffect) {
    FSharpMap__get_Item(soundEffects, soundEffect)(volume);
}

